// Dependencies
import React from "react";
import NumberFormat from 'react-number-format';

import { CSSTransition } from 'react-transition-group';
import { CSSTransitionProps } from 'react-transition-group/CSSTransition';

// Utils
import { } from '../utils/config';
import { } from '../utils/helpers';

// Components.Price
const Price = ({type = 'default', value, className, loading = false, config: {general: {currency, ...general}}, theme, translations, priceTaxClass, priceDisplayMode}: any) => {

		const transitionProps: CSSTransitionProps = React.useMemo(() => ({
			timeout: Number(theme.general.transition.duration.replace('ms', '')),
			unmountOnExit: true
		}), [theme.general.transition.duration])

		return (
			<CSSTransition {...transitionProps} in={ ! loading } >
				<div className={['wooptima-price', ...(className ?? [])].join(' ')}>
					<NumberFormat
						value={value}
						decimalScale={general.decimals ?? 2}
						decimalSeparator={general.decimalSeparator ?? ','}
						thousandSeparator={general.thousandSeparator ?? ' '}
						displayType="text"
						allowNegative={false}
						allowLeadingZeros={true}
						fixedDecimalScale={true}
						renderText={(value: string) => <span className={`wooptima-price--value`}>{value}</span>}
					/>
					<span className={`wooptima-price--currency`}>{currency.symbol}</span>
				</div>
			</CSSTransition>
		) 
}

export default Price; 